import { useMutation } from "@tanstack/react-query";
import { toastr } from "react-redux-toastr";

import { client, getApiErrorMessage } from "utils/api";

const useDelete = ({
  path,
  onSuccess,
  success_message = "Usunięto pomyślnie",
  success_message_enabled = true,
  error_message_enabled = true,
}) => {
  const { isLoading: is_deleting, mutateAsync: _delete } = useMutation({
    mutationFn: () => client.delete(path),
    onSuccess: () => {
      if (success_message_enabled) {
        toastr.success("Sukces", success_message);
      }
      onSuccess?.();
    },
    onError: (err) => {
      if (error_message_enabled) {
        toastr.error("Błąd", getApiErrorMessage(err));
      }
    },
  });

  return { is_deleting, _delete };
};

export default useDelete;
